import { createColumnHelper } from '@tanstack/react-table';
import { Badge, Flex, Icon, Text, useColorModeValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaEye } from 'react-icons/fa';
import { SubscriptionPlan } from 'services/@types';

const columnHelper = createColumnHelper<SubscriptionPlan>();

export default function useColumns(): any {
  const navigate = useNavigate();
  const textColor = useColorModeValue('navy.700', 'white');
  const brandColor = useColorModeValue('brand.500', 'brand.400');

  return [
    columnHelper.accessor('name', {
      id: 'name',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
          Name
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="md" fontWeight="600">
          {info.getValue()}
        </Text>
      ),
    }),
    columnHelper.accessor('period', {
      id: 'period',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
          Period
        </Text>
      ),
      cell: (info) => (
        <Badge
          colorScheme={info.getValue() === 'year' ? 'purple' : 'blue'}
          fontSize="xs"
          borderRadius="6px"
        >
          {info.getValue()}
        </Badge>
      ),
    }),
    columnHelper.accessor('grade', {
      id: 'grade',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
          Grade
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="md" fontWeight="500">
          {info.getValue() ?? '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('price', {
      id: 'price',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
          Price (ILS)
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="md" fontWeight="500">
          {info.getValue()?.ils != null ? `${info.getValue().ils} ILS` : '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('design', {
      id: 'design',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
          Design
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm">
          {info.getValue() || '-'}
        </Text>
      ),
    }),
    columnHelper.accessor('visible', {
      id: 'visible',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
          Visible
        </Text>
      ),
      cell: (info) => (
        <Badge
          colorScheme={info.getValue() ? 'green' : 'gray'}
          fontSize="xs"
          borderRadius="6px"
        >
          {info.getValue() ? 'Yes' : 'No'}
        </Badge>
      ),
    }),
    columnHelper.accessor('id', {
      id: 'actions',
      header: () => {},
      cell: (info) => (
        <Flex gap={5}>
          <Icon
            as={FaEye}
            color={brandColor}
            onClick={() =>
              navigate(`/admin/subscription_plans/detail/${info.getValue()}`)
            }
            transition="all 0.2s linear"
            cursor="pointer"
            _hover={{ transform: 'scale(1.2)' }}
          />
          <Icon
            as={FaEdit}
            color={brandColor}
            onClick={() =>
              navigate(`/admin/subscription_plans/detail/${info.getValue()}`)
            }
            transition="all 0.2s linear"
            cursor="pointer"
            _hover={{ transform: 'scale(1.2)' }}
          />
        </Flex>
      ),
    }),
  ];
}
